import regex from './regex';

export default {
  username (uid) {
    let suggestion = '';
    if (!uid.charAt(0).match(/[a-z]/)){
      suggestion = 'Usernames must begin with a lowercase letter'
    }
    else if (uid.length < 3)
    {
      suggestion = 'Usernames must be at least 3 characters long'
    }
    else if (uid.length > 48) {
      suggestion = 'Usernames cannot be longer than 48 characters'
    }
    else if (!uid.match(regex.uid)){
      suggestion = 'Usernames can only contain lowercase letters, numbers, dashes, and underscores'
    }
    return {valid: ((typeof uid) === 'string') && (uid.length > 0) && regex.uid.test(uid),
            suggestion: suggestion, regex: regex.uid};
  }
};



// WEBPACK FOOTER //
// ./src/lib/validators.js